import './includes'
import './closest'
import './classlist'
import './foreach'
import 'url-search-params-polyfill'


// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/polyfill/polyfill.js